<div class="col full-height layout-column" *ngIf="vm">

  <!--Panel Skeleton, shown only until the services have loaded for the first time-->
  <app-card-skeleton *ngIf="!vm.initialized" class="flex" [rows]="8"></app-card-skeleton>

  <div *ngIf="vm.initialized" class="flex layout-column dndList overflow-auto"
       cdkDropList
       [cdkDropListData]="vm.services"
       id="{{panel.id}}"
       [cdkDropListEnterPredicate]="enterPredicate"
       [cdkDropListSortingDisabled]="true"
       [cdkDropListConnectedTo]="allPanelIds"
       (cdkDropListDropped)="drop($event)">


    <!--    <div class="route-item-test"-->
    <!--         *ngFor="let task of route.taskListExt;let index = index"-->
    <!--         cdkDrag-->
    <!--         [cdkDragData]="task">-->
    <!--      {{task.id}}-->
    <!--    </div>-->

    <cdk-virtual-scroll-viewport class="flex layout-column"
                                 (scroll)="getNextBatch($event)" autosize>

      <app-services-panel-list-item *cdkVirtualFor="let service of vm.services; trackBy: trackById"
                                    [service]="service"
                                    [isSelected]="selectedKeys[service.id]"
                                    [settings]="settings"
                                    [itemElementSize]="itemElementSize"
                                    cdkDrag
                                    [cdkDragData]="service"
                                    (onSplitByPackages)="onSplitByPackages.emit($event)"
                                    (onToggle)="onToggleSelection(service.id, $event)"
                                    (onDrillDown)="onDrillDown.emit($event)">

        <div *ngIf="selectedIds?.length > 1 && selectedKeys[service.id]">
          <div *cdkDragPreview id="app-planning-draft-jobs-panel-editable-list-preview-drag-multiple-jobs-container">
            {{ 'DRAGGING_X_ITEMS.JOBS' | translate:{X: selectedIds.length} }}
          </div>
        </div>

      </app-services-panel-list-item>

    </cdk-virtual-scroll-viewport>

      <app-bringoz-linear-progress *ngIf="!!vm.loading"></app-bringoz-linear-progress>


      <div *ngIf="!vm.services?.length && !vm.loading"
           class="flex-100 layout-row layout-align-center-center fade-element-in-only overflow-auto">
        <app-empty-state src="assets/images/empty_state/empty_state_dispatching.png"
                         text="No Services Found">

        </app-empty-state>
      </div>

  </div>

</div>
